<!-- <nz-table *ngIf="_inputOtherPoliciesComponent && _inputOtherPoliciesComponent.length > 0" [nzShowPagination]="false"
    #SearchTable [nzData]="[1]">
    <thead>
        <tr>

            <th>Provider</th>
            <th>Policy Number</th>
            <th>{{appMetadataHandler.SI_LABEL}}</th>
            <th>Premium</th>
            <th>Actions</th>
        </tr>
    </thead>
    <tbody>
        <ng-container *ngFor="let data of _inputOtherPoliciesComponent; let i=index">
            <tr *ngIf="!_inputOtherPoliciesComponent[i]['remove']">
                <td>{{data.provider | technicalTranslate}}</td>
                <td>{{data.policyNum || '-'}}</td>
                <td>{{data.sumInsured | CurrencyFormatter}}</td>
                <td>{{data.premium | CurrencyFormatter}}</td>
                <td>
                    <ng-container>
                        <a [class.isDisabled]="disabledButtonclientListExists" *ngIf="!data['isExtractedFromPolicy']"
                            nz-popconfirm nzPopconfirmTitle="Remove this policy from the list?" nzOkText="Remove"
                            nzCancelText="Cancel"
                            (nzOnConfirm)="_inputOtherPoliciesComponent[i]['remove'] = !_inputOtherPoliciesComponent[i]['remove']">Remove</a>
                    </ng-container>
                </td>
            </tr>
        </ng-container>
    </tbody>
</nz-table>
<app-generic-zero-ui [list]="_inputOtherPoliciesComponent" icon="file-search" title="No Other Policies Found">
</app-generic-zero-ui> -->


<div class="flexie-auto-grid m-t-b-60">
    <div class="flex-self-vert-start">
        <div *ngIf="otherPolicyList && otherPolicyList.length < 1">
            <div class="zero-ui">
                <i nz-icon nzType="schedule" nzTheme="outline"></i>
                <h2 translate>Add Other Policy Details</h2>
                <!-- <p translate>You need to at-least one address to continue</p> -->
            </div>
        </div>
        <div *ngIf="otherPolicyList && otherPolicyList.length > 0">
            <h3 translate> Other Policy Details</h3>

            <div *ngFor="let item of otherPolicyList; let i = index;"
                class="flex flex-dir-horiz flex-horiz-space-bw flex-vert-center b-b-1 p-10">
                <div>

                    <strong>{{item?.policyNum}}</strong><br>
                    <span>Provider: {{item?.provider | technicalTranslate}}</span><br>
                    <span>{{appMetadataHandler?.SI_LABEL}}: {{item.sumInsured | CurrencyFormatter : (item.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)}}</span><br>
                    <span *ngIf="item.term">Term: {{item.term}}</span><br>
                    <span>Premium: {{item?.premium | CurrencyFormatter : (item.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)}}</span><br>
                    <span>Policy Status: {{item?.statusCd | technicalTranslate: 'policyStatusCd'}}</span>
                </div>
                <div>
                    <a href="javascript:void(0)" (click)="editOtherPolicyDetails(item,i)">Edit</a> |
                    <a href="javascript:void(0)" (click)="removeOtherPolicyDetails(i)">Remove</a>
                </div>
            </div>
        </div>
    </div>
    <div class="flex-self-vert-start" style="align-self: flex-start;">
        <div class="form-secondary">
            <h3 class="form-secondary-heading" translate>+ Add Other Policy Details</h3>
            <form [formGroup]="otherPolicyForm" class="form-secondary-fields p-l-r-20 p-t-b-10">
                <nz-form-item>
                    <nz-form-label [nzSpan]="24"><span translate>Provider</span></nz-form-label>
                    <nz-form-control [nzSpan]="24">
                        <nz-select nzShowSearch id="provider" formControlName="provider" style="width: 100%">
                            <nz-option
                                *ngFor="let item of (lookup$['insuranceProvider'] | async) as providerCdLookup; trackBy:item?.lookupKey"
                                [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>

                <!-- <nz-form-item>
                    <nz-form-label [nzSpan]="24"><span translate>Product Name</span></nz-form-label>
                    <nz-form-control [nzSpan]="24">
                        <input nz-input placeholder="{{'Product Name' | translate}}" formControlName="productName" />
                    </nz-form-control>
                </nz-form-item> -->

                <nz-form-item>
                    <nz-form-label [nzSpan]="24"><span translate>Policy Number</span></nz-form-label>
                    <nz-form-control [nzSpan]="24">
                        <input nz-input placeholder="{{'Policy Number' | translate}}" formControlName="policyNumber" />
                        <!-- <nz-form-explain
                  *ngIf="(uiAddressIndForm.get('addressLine1').dirty || uiAddressIndForm.get('addressLine1').touched) && uiAddressIndForm.get('addressLine1').errors">
                  <p style="color:red"
                    *ngFor="let error of validationUtilService.getUIErrorList(uiAddressIndForm.get('addressLine1'), UIADDRESSINDFORMNAME)">
                    {{error || '' |translate}}</p>
                </nz-form-explain> -->
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                    <nz-form-label [nzSpan]="24">Policy Expiry Date</nz-form-label>
                    <nz-form-control [nzSpan]="24">
                        <nz-date-picker nzFormat="dd MMM yyyy" formControlName="policyExpiryDt">
                        </nz-date-picker>
                        <!-- <nz-form-explain
                    *ngIf="(SubmissionDataForm.get('expiryDate').dirty || SubmissionDataForm.get('expiryDate').touched) && SubmissionDataForm.get('expiryDate').errors">
                    <p style="color:red"
                      *ngFor="let error of validationUtilService.getUIErrorList(SubmissionDataForm.get('expiryDate'), SUBMISSIONDATAFORMNAME)">
                      {{error}}</p>
                  </nz-form-explain> -->
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                    <nz-form-label [nzSpan]="24"><span translate>{{appMetadataHandler.SI_LABEL}}</span></nz-form-label>
                    <nz-form-control [nzSpan]="24">
                        <nz-input-group><input currencyMask type="text" [options]="appMetadataHandler.currencyOptions"
                                nz-input formControlName="sumInsured" placeholder="{{appMetadataHandler.SI_LABEL | translate}}" />
                        </nz-input-group>
                        <!-- <nz-form-explain
                  *ngIf="(uiAddressIndForm.get('addressLine1').dirty || uiAddressIndForm.get('addressLine1').touched) && uiAddressIndForm.get('addressLine1').errors">
                  <p style="color:red"
                    *ngFor="let error of validationUtilService.getUIErrorList(uiAddressIndForm.get('addressLine1'), UIADDRESSINDFORMNAME)">
                    {{error || '' |translate}}</p>
                </nz-form-explain> -->
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSpan]="24"><span translate>Premium</span></nz-form-label>
                    <nz-form-control [nzSpan]="24">
                        <nz-input-group><input currencyMask type="text" [options]="appMetadataHandler.currencyOptions"
                                nz-input formControlName="premium" placeholder="{{'Premium' | translate}}" />
                        </nz-input-group>
                        <!-- <nz-form-explain
                  *ngIf="(uiAddressIndForm.get('addressLine1').dirty || uiAddressIndForm.get('addressLine1').touched) && uiAddressIndForm.get('addressLine1').errors">
                  <p style="color:red"
                    *ngFor="let error of validationUtilService.getUIErrorList(uiAddressIndForm.get('addressLine1'), UIADDRESSINDFORMNAME)">
                    {{error || '' |translate}}</p>
                </nz-form-explain> -->
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSpan]="24"><span translate>Term</span></nz-form-label>
                    <nz-form-control [nzSpan]="24">
                        <input nz-input placeholder="{{'Term' | translate}}" formControlName="term" />
                        <!-- <nz-form-explain
                              *ngIf="(uiAddressIndForm.get('addressLine1').dirty || uiAddressIndForm.get('addressLine1').touched) && uiAddressIndForm.get('addressLine1').errors">
                              <p style="color:red"
                                *ngFor="let error of validationUtilService.getUIErrorList(uiAddressIndForm.get('addressLine1'), UIADDRESSINDFORMNAME)">
                                {{error || '' |translate}}</p>
                            </nz-form-explain> -->
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSpan]="24"><span translate>Policy Status</span></nz-form-label>
                    <nz-form-control [nzSpan]="24">
                        <nz-select nzShowSearch formControlName="policyStatus" style="width: 100%">
                            <nz-option
                                *ngFor="let item of (lookup$['policyStatusCd'] | async) as policyStatusCdLookup; trackBy:item?.lookupKey"
                                [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                        </nz-select>
                        <!-- <input nz-input placeholder="{{'Policy Status' | translate}}" formControlName="policyStatus" /> -->
                        <!-- <nz-form-explain
                                *ngIf="(uiAddressIndForm.get('addressLine1').dirty || uiAddressIndForm.get('addressLine1').touched) && uiAddressIndForm.get('addressLine1').errors">
                                <p style="color:red"
                                  *ngFor="let error of validationUtilService.getUIErrorList(uiAddressIndForm.get('addressLine1'), UIADDRESSINDFORMNAME)">
                                  {{error || '' |translate}}</p>
                              </nz-form-explain> -->
                    </nz-form-control>
                </nz-form-item>

            </form>


            <div class="footer-actions-bar">
                <div>
                    <!-- Left -->
                </div>
                <div>
                    <!-- Right -->
                    <button nz-button class="b-0 m-r-10" (click)="clearForm()"><span translate>Clear</span></button>
                    <button nz-button [nzType]="'primary'" (click)="addOtherPolicyDetails()"><span
                            translate>Add</span></button>
                </div>
            </div>
        </div>
    </div>

</div>